import * as React from "react";
import { Link } from "react-router-dom";
import cctLogo from "../assets/cct-logo.png";
import ChangeCouncilsButton from "../assets/change-councils-btn.png";
import JumpToButton from "../assets/jump-to-btn.png";
import JumpToButtonSelected from "../assets/jump-to-btn-selected.png";
import { connect } from "react-redux";
import { toggleJumpTo } from "../actions"
import { Dispatch } from "redux";


export const Header = () => (
  <header className="c-header bg-white p-4 border-b w-full">
    <img src={cctLogo} alt="My Council Story" className="cct-logo" />
  </header>
);


interface IProps {
  whoOpened: string|null,
  toggleJumpTo: any
}

export class ReportHeader extends React.Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      jumpToSelected: false
    };
  }


  public clickJumpTo = () => {
    this.props.toggleJumpTo(this.props.whoOpened)
  };

  public render() {
    return (
      <header className="c-header bg-white p-4 border-b w-full" id="header">
        <div className="flex flex-wrap justify-between items-center">
          <Link to="select">
            <img
              src={cctLogo}
              alt="My Council Story"
              className="cct-logo"
            />
          </Link>
          <div>
            <Link to="select" className="btn">
              <img src={ChangeCouncilsButton} alt="Change Council Button" />
            </Link>
            <img
              className="btn pl-2 cursor-pointer"
              src={
                this.props.whoOpened !== "JUMPTO" ?  JumpToButton : JumpToButtonSelected
              }
              alt="Jump to Button"
              onClick={this.clickJumpTo}
            />
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state: any) => ({
  whoOpened: state.navbar.whoOpened
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleJumpTo: (whoOpened: string|null) => dispatch(toggleJumpTo(whoOpened))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportHeader)



// WEBPACK FOOTER //
// ./src/components/Header.tsx